<template>
    <div class="modal fade" id="applyImplantConfirmModal" tabindex="-1">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h6 class="modal-title" id="exampleModalLabel">Δήλωση εισαγωγής μοσχεύματος</h6>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <p>Εισαγωγή του μοσχεύματος;</p>
                </div>
                <div class="modal-footer">
                    
                    <button type="button" class="btn" data-bs-dismiss="modal" @click="cancelModal"><img src="../assets/images/close16.png" alt="Citrine Logo" class="menu-img" style="width:1.1em; margin-right:10px">Άκυρο</button>
                    <button type="submit" class="btn" @click="save"><img src="../assets/images/save16.png" alt="Citrine Logo" class="menu-img" style="width:1.1em; margin-right:10px">Υποβολή</button>
                </div>
            </div>
        </div>
    </div>
    <div>
        <!-- Tabs Content -->
        <div class="d-flex mt-4">

            <!-- Main Content Area -->
            <div class="content-area" :class="{ 'shrink': implantShown, 'expand': !implantShown }">
                <div>
                    <div class="d-flex">
                        <label for="institute_relations ms-2 mt-3" style="margin-right:20px; margin-top:10px"
                            class="form-label">
                            Αναζήτηση με:
                        </label>
                        <select name="institute_relations ms-2" style="max-width:30%" class="form-control"
                            v-model="searchField" placeholder="Επιλέξτε κριτήριο" @change="handleRefresh">
                            <option value="" selected>Επιλέξτε...</option>
                            <option value="implant_name">Μοσχευμα</option>
                            <option value="category">Κατηγορία</option>
                            <option value="provider_name">Προμηθευτής</option>
                            <option value="hospital_name">Μονάδα εφαρμογής</option>
                            <option value="sec">Κωδικός SEC</option>
                        </select>
                        <input type="text" class="form-control ms-2" style="max-width:30%" v-model="searchValue"
                            placeholder="Κριτήριο..." />
                        <button class="btn ms-2" @click="handleExport()">
                            <img src="../assets/images/excel16.png" alt="Excel" class="menu-img"
                                style="width:1.1em; margin-right:10px">
                            MS-Excel
                        </button>
                    </div>

                    <table class="table table-bordered table-hover table-striped">
                        <tr style="border-bottom: 2px solid gray; ">
                            <td></td>
                            <td style="padding-left:15px">Σύνολο: {{ implants ? implants.length : 0 }}</td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>

                        <thead class="table-light">
                            <tr>
                                <th @click="sortTable('id')">
                                    Α/Α
                                    <span v-if="sortKey === 'id'">
                                        <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                    </span>
                                </th>
                                <th @click="sortTable('category')">
                                    Κατηγορια
                                    <span v-if="sortKey === 'category'">
                                        <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                    </span>
                                </th>
                                <th @click="sortTable('implant_name')">
                                    Μοσχευμα
                                    <span v-if="sortKey === 'implant_name'">
                                        <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                    </span>
                                </th>
                                <th @click="sortTable('inst_insdate')">
                                    Ημ/νια Υποβολης Δ...
                                    <span v-if="sortKey === 'inst_insdate'">
                                        <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                    </span>
                                </th>
                                <th @click="sortTable('inst_recvdate')">
                                    Ημ/νια Παραλαβης
                                    <span v-if="sortKey === 'inst_recvdate'">
                                        <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                    </span>
                                </th>
                                <th @click="sortTable('sec')">
                                    Κωδικος SEC
                                    <span v-if="sortKey === 'sec'">
                                        <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                    </span>
                                </th>
                                <th @click="sortTable('provider_name')">
                                    Προμηθευτης
                                    <span v-if="sortKey === 'provider_name'">
                                        <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                    </span>
                                </th>
                                <th @click="sortTable('proto_num')">
                                    Αρ. Πρωτοκ...
                                    <span v-if="sortKey === 'proto_num'">
                                        <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                    </span>
                                </th>
                                <th @click="sortTable('proto_date')">
                                    Ημ/νια εκτελ...
                                    <span v-if="sortKey === 'proto_date'">
                                        <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                    </span>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="implant in implants" :key="implant.id" @click="showImplant(implant)"
                                @dblclick="openApplyModal(implant)"
                                :class="{ active2: selectedRow?.id === implant.id }">
                                <td>
                                    <!-- <img src="../assets/images/implant16.png" alt="To Be Applied Icon" class="menu-img"
                                        style="width:1.3em; margin-right:5px" /> -->{{ implant.id }}
                                </td>
                                <td>{{ implant.category }}</td>
                                <td>{{ implant.implant_name }}</td>
                                <td>{{ formatLicenseExp(implant.inst_insdate) }}</td>
                                <td>{{ formatLicenseExp(implant.inst_recvdate) }}</td>
                                <td>{{ limitSec(implant.sec) }}</td>
                                <td>{{ implant.provider_name }}</td>
                                <td>{{ implant.proto_num }}</td>
                                <td>{{ formatLicenseExp(implant.proto_date) }}</td>
                            </tr>
                        </tbody>
                    </table>
                    <nav aria-label="Page navigation" v-if="paginationLinks && paginationLinks.length > 1">
                        <ul class="pagination mt-4" >
                            <li class="page-item" v-for="(paginationLink, index) in paginationLinks" :key="index"
                                :class="{ active: paginationLink.active }">
                                <router-link
                                    :to="{ path: 'temp-saved-implants', query: { page: getPageFromUrl(paginationLink.url) } }"
                                    v-if="paginationLink.url">
                                    <span class="page-link" v-html="paginationLink.label"></span>
                                </router-link>
                                <span class="page-link" v-else v-html="paginationLink.label"></span>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div> <!-- Implant Details -->
            <div class="implant_details" v-if="implantShown">
                <div class="d-flex align-items-center justify-content-between mb-4 mt-2 me-1">
                    <label class="fw-bolder mb-0 me-2" style="font-size: large; white-space: nowrap;">
                        Στοιχεία Μοσχεύματος
                    </label>
                    <div class="d-flex ms-auto">
                        <button class="btn me-2" @click="printPreview">
                            <img src="../assets/images/print.png" alt="Preview" class="menu-img" style="width: 1.1em;">

                        </button>
                        <button class="btn me-2" @click="download">
                            <img src="../assets/images/preview16.png" alt="Download" class="menu-img"
                                style="width: 1.1em;">

                        </button>
                        <button class="btn" @click="closeDetails">
                            <img src="../assets/images/hide16.png" alt="Hide" class="menu-img" style="width: 1.1em;">
                        </button>
                    </div>
                </div>
                <h5 class="mb-4">{{ selectedImplant.implant_name }}</h5>
                <div class="implant-details-container">
                    <div class="implant-detail shadow mb-2">
                        <strong class="label-text">Α/Α</strong>
                        <div class="value-text">{{ selectedImplant.id }}</div>
                    </div>

                    <div class="implant-detail shadow mb-2">
                        <strong class="label-text">Κατηγορία</strong>
                        <div class="value-text">{{ selectedImplant.category }}</div>
                    </div>

                    <div class="d-flex justify-content-between" style="width: calc(100% - 20px);">
                        <div class="implant-detail shadow mb-2">
                            <strong class="label-text">Ημ/νία Δήλωσης</strong>
                            <div class="value-text">{{ formatLicenseExp(selectedImplant.inst_insdate) }}</div>
                        </div>

                        <div class="implant-detail shadow mb-2 ms-2">
                            <strong class="label-text">Ημ/νία Παραλαβής</strong>
                            <div class="value-text">{{ formatLicenseExp(selectedImplant.inst_recvdate) }}</div>
                        </div>

                    </div>



                    <div class="implant-detail shadow mb-2">
                        <strong class="label-text">Ημ/νια Λήξης</strong>
                        <div class="value-text">{{ formatLicenseExp(selectedImplant.exp_date) }}</div>
                    </div>

                    <div class="implant-detail shadow mb-2">
                        <strong class="label-text">Κωδικός SEC</strong>
                        <div class="value-text">{{ selectedImplant.sec }}</div>
                    </div>

                    <div class="implant-detail shadow mb-2">
                        <strong class="label-text">Προμηθευτής</strong>
                        <div class="value-text">{{ selectedImplant.provider_name ? selectedImplant.provider_name : '-'
                            }}</div>
                    </div>

                    <div class="implant-detail shadow mb-2">
                        <strong class="label-text">Αριθμός Πρωτοκόλλου Εκτελωνισμού
                        </strong>
                        <div class="value-text">{{ selectedImplant.proto_num ? selectedImplant.proto_num : '-' }}</div>
                    </div>

                    <div class="implant-detail shadow mb-2">
                        <strong class="label-text">Ημ/νία Εκτελωνισμού</strong>
                        <div class="value-text">{{ selectedImplant.proto_date ?
                            formatLicenseExp(selectedImplant.proto_date) : '-' }}
                        </div>
                    </div>

                </div>

            </div>
        </div>
    </div>
    <!-- Bootstrap Modal -->
    <div class="modal fade" id="printModal" tabindex="-1" aria-labelledby="printModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="printModalLabel">Προεπισκόπηση εκτύπωσης</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div id="printContent">
                        <!-- This is where the content for printing will go -->
                        <p>Παρακαλώ περιμένετε...</p>
                    </div>
                </div>
              
            </div>
        </div>
    </div>
    <div class="modal fade" id="applyModal" tabindex="-1" aria-labelledby="applyModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="applyModalLabel">Δήλωση εισαγωγής μοσχεύματος</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="d-flex">
                        <label style="color:#CCCCCC">Κωδικός SEC:</label>
                        <p class="ms-2"><b>{{ selectedImplant?.sec }}</b></p>
                    </div>
                    <div class="d-flex">

                        <label style="color:#CCCCCC">Μόσχευμα:</label>
                        <p class="ms-2"><b>{{ selectedImplant?.implant_name }}</b></p>
                    </div>
                    <div class="d-flex">

                        <label style="color:#CCCCCC">Προμηθευτής:</label>
                        <p class="ms-2"><b>{{ selectedImplant?.provider_name }}</b></p>
                    </div>
                  
                </div>
                <div class="modal-footer justify-content-end">
                    
                    <div class="d-flex">
                        <button type="button" class="btn" data-bs-dismiss="modal"><img
                                src="../assets/images/close16.png" alt="Citrine Logo" class="menu-img"
                                style="width:1.1em; margin-right:10px">Άκυρο</button>
                        <button type="button" class="btn ms-2" @click="saveModal"><img src="../assets/images/save16.png"
                                alt="Citrine Logo" class="menu-img"
                                style="width:1.1em; margin-right:10px">Υποβολή</button>

                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade" id="infoModal" tabindex="-1" aria-labelledby="infoModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="infoModalLabel">Πληροφορία</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="d-flex">
                        <p>Αναζητήστε το μόσχευμα που θέλετε να δηλώσετε, κάντε διπλό κλικ και συμπληρώστε τη φόρμα
                            δήλωσης.</p>
                    </div>
                </div>
                <div class="modal-footer justify-content-center">
                    <button type="button" class="btn" data-bs-dismiss="modal" style="background-color: #6DB4E3; color:white; min-width:80px; shadow:0">OK</button>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import { getNotUsed, downloadExportInstall, downloadFile, downloadExportNotUsed, fetchUserInfo } from "../services/institutions";
import { deleteHospitalById, downloadExportHospitals, getHospitals, getHospitalsAll, getHospitalsForInstitute, postHospital } from "@/services/hospitals";
import { getGrafts, getGraftCategories, postCategory, postImplant, actImplant, deleteRelationsForImplant, instToHosp, instToApply, getTempSavedApplies, downloadExportTempSavedImplants } from "@/services/grafts";
import { useToast } from "vue-toastification";
import apiClient from "@/services/api";
import * as XLSX from 'xlsx';
import { actProvider, deleteRelationsForProvider, getCountries, getSuppliers, postProvider } from "@/services/suppliers";

export default {
    data() {
        return {
            totalCount: 0,
            applyDate: "",
            selectedHospitalId: "",
            selectedHospitalAfm: null,
            searchField: "",
            searchValue: "",
            implants: [],
            hospitals: [],
            installedImplants: [],
            notUsedImplants: [],
            usedImplants: [],
            expiredImplants: [],
            paginationLinks: [],
            page: 1,
            selectedInsituteId: "0",
            selectedImplant: null,
            sortKey: "id",
            sortOrder: "desc",
            selectedField: "",
            implantShown: false,
            selectedRow: null,

        };
    },
    methods: {
        async tempSave() {
            const hospId = this.selectedHospitalId;
            const applyDate = this.applyDate;
            if (hospId == '') {
                useToast().error('Πρέπει να επιλέξετε μονάδα εφαρμογής');
            }
            if (applyDate == '') {
                useToast().error('Πρέπει να επιλέξετε ημ/νία εφαρμογής μοσχεύματος');
            }
            if (!this.selectedImplant) {
                useToast().error('Πρέπει να επιλέξετε μόσχευμα');
            }
            const response = await instToHosp({ id: this.selectedImplant.id, hospid: hospId, todate: applyDate, istemp: 1 });
            if (response.data.success) {
                $("#applyModal").modal('toggle');
                useToast().success('Επιτυχής υποβολή δήλωσης μοσχεύματος');
            } else {
                useToast().error('Αποτυχία υποβολής δήλωσης μοσχεύματος');
            }
        },
        saveModal() {
          
            $("#applyImplantConfirmModal").modal('show');
            $("#applyModal").modal('hide');
        },
        cancelModal() {
            $("#applyImplantConfirmModal").modal('hide');
            $("#applyModal").modal('show');
        },
        async save() {
            const hospId = this.selectedHospitalId;
            const applyDate = this.applyDate;
            const response = await instToApply({ id: this.selectedImplant.id,  istemp: 0 });
            if (response.data.success) {
                $("#applyImplantConfirmModal").modal('toggle');
                useToast().success('Επιτυχής υποβολή δήλωσης μοσχεύματος');
                this.handleRefresh();
            } else {
                useToast().error(response.data.message);
            }
        },
        limitSec(sec) {
            if (sec && sec.length > 10) {
                return sec.substring(0, 10) + '...';
            }
            return sec;
        },
        async openApplyModal() {
            $("#applyModal").modal('toggle');
            if (this.selectedImplant) {
                this.selectedHospitalId = this.selectedImplant.prov_hospital_id;
                this.applyDate = this.selectedImplant.inst_to_hospdate;
            }
            const userInfo = await fetchUserInfo();
            const hospitalsResponse = await getHospitalsForInstitute({ instid: userInfo.data.institution.id });
            if (hospitalsResponse.data.success) {
                this.hospitals = hospitalsResponse.data.data;
            }
        },
        printPreview() {
            $("#printModal").modal('toggle');

            apiClient.get('/eomws/print-implant/' + this.selectedImplant.id, {
                responseType: 'text', // Expect text to handle HTML responses
                headers: {
                    "Accept": "text/html", // Expect an HTML response
                },
            })
                .then((response) => {
                    // Close the modal
                    setTimeout(() => {
                        $("#printModal").modal('hide');
                    }, 1000);

                    // Check the content type of the response
                    const contentType = response.headers['content-type'];
                    if (contentType.includes('text/html')) {
                        // Create an iframe element
                        const iframe = document.createElement('iframe');
                        iframe.style.position = 'absolute';
                        iframe.style.top = '0';
                        iframe.style.left = '0';
                        iframe.style.width = '0';
                        iframe.style.height = '0';
                        iframe.style.border = 'none';
                        document.body.appendChild(iframe);

                        // Write the printable content into the iframe
                        const iframeDoc = iframe.contentWindow.document;
                        iframeDoc.open();
                        iframeDoc.write(response.data); // Write the HTML content to the iframe
                        iframeDoc.close();

                        // Wait for the content to load, then print
                        iframe.onload = () => {
                            iframe.contentWindow.focus();
                            iframe.contentWindow.print();

                            // Clean up after printing
                            setTimeout(() => {
                                document.body.removeChild(iframe); // Remove the iframe after printing
                            }, 1000); // Delay to ensure the print dialog is completed
                        };
                    } else {
                        console.error('Unexpected content type:', contentType);
                    }
                })
                .catch((error) => {
                    // Close the modal and log the error
                    $("#printModal").modal('toggle');
                    console.error('Error in print preview:', error);
                });
        },
        download() {
            if (!this.selectedImplant.file_name) {
                useToast().error('Δεν υπάρχει αρχείο!');
            } else {
                downloadFile(this.selectedImplant.id, this.selectedImplant.file_name, this.selectedImplant.mime_type);
            }
        },
        closeDetails() {
            this.implantShown = false;
        },
        onChangeHospital() {
            let hospital = null;
            for (let i = 0; i < this.institutions.length; i++) {
                if (this.institutions[i].id == $("#hospital").val()) {
                    hospital = this.institutions[i];
                }
            }
            if (hospital) {
                this.selectedHospitalAfm = hospital.afm;
            } else {
                this.selectedHospitalAfm = null;
            }
        },
        showImplant(implant) {
            this.selectedImplant = implant;
            this.implantShown = true;
            this.selectedRow = implant;
        },
        sortTable(column) {
            if (this.sortKey === column) {
                // Reverse order if the column is already sorted
                this.sortOrder = this.sortOrder === "asc" ? "desc" : "asc";
            } else {
                this.sortKey = column;
                this.sortOrder = "asc";
            }
            this.handleRefresh();
        },
        getPageFromUrl(url) {
            if (!url) return null;
            const urlObj = new URL(url, window.location.origin);
            return urlObj.searchParams.get('page');
        },
        resetInstitute() {
            this.selectedInsituteId = "0";
            this.handleRefresh();
        },
        async handleRefresh() {
            let params = {
                sortBy: this.sortKey,
                sortOrder: this.sortOrder,
                page: this.page
            };
            if (this.searchField != "" && this.searchValue != "") {
                params[this.searchField] = this.searchValue;
            }
            const userInfo = await fetchUserInfo();
            params.instid = userInfo.data.institution.id;
            const implants = (await getTempSavedApplies(params)).data;
            this.implants = implants.data.results.data;
            this.paginationLinks = implants.data.results.links;
            this.totalCount = implants.data.count;
        },
        async handleExport() {
            let params = {
                sortBy: this.sortKey,
                sortOrder: this.sortOrder,
                page: this.page
            };
            if (this.searchField != "" && this.searchValue != "") {
                params[this.searchField] = this.searchValue;
            }
            const userInfo = await fetchUserInfo();
            params.instid = userInfo.data.institution.id;
            downloadExportTempSavedImplants(params);
        },
        formatLicenseExp(date) {
            if (date == null) { return ''}
            return new Date(date).toLocaleDateString("el-GR", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
            });
        },
        openInfoModal() {
            $("#infoModal").modal('show');
        }
    },
    async mounted() {
        const userInfo = await fetchUserInfo();
        const implants = (await getTempSavedApplies({ instid: userInfo.data.institution.id })).data;
        this.implants = implants.data.results.data;
        this.paginationLinks = implants.data.results.links;
        this.totalCount = implants.data.count;
    },
    watch: {
        $route: {
            immediate: true,
            handler(newRoute) {
                const page = newRoute.query.page || 1; // Default to page 1 if not in URL
                this.page = page;
                this.handleRefresh();
            }
        },
        selectedInsituteId: {
            immediate: true,
            handler() {
                this.page = 1; // Reset to page 1
                // Update the URL with page = 1
                this.$router.push({
                    path: this.$route.path,
                    query: { ...this.$route.query, page: 1 }
                });
                this.handleRefresh();
            }
        },
        searchField: {
            handler() {
                this.page = 1; // Reset to page 1
                // Update the URL with page = 1
                this.$router.push({
                    path: this.$route.path,
                    query: { ...this.$route.query, page: 1 }
                });
                this.handleRefresh();
            }
        },
        searchValue: {
            handler() {
                this.page = 1; // Reset to page 1
                // Update the URL with page = 1
                this.$router.push({
                    path: this.$route.path,
                    query: { ...this.$route.query, page: 1 }
                });
                this.handleRefresh();
            }
        }
    }
};
</script>

<style scoped>
.nav-tabs {
    border-bottom: 1px solid #ddd;
}

.nav-link {
    cursor: pointer;
}

.table {
    margin-top: 1rem;
    width: 100%;
}

.btn {
    background-color: #f6f6f6;
}

.btn:hover,
.btn-md:hover {
    background-color: #ececec;
}

.btn-md {
    background-color: white;
    border: none;
}

.page-container {
    display: flex;
    width: 100%;
    height: 100%;
    /* Ensures the layout fits the screen height */
    overflow: hidden;
    /* Prevent overflow when zoomed */
}

.content-area {
    flex: 1;
    /* Default flex value */
    transition: all 0.3s ease-in-out;
    min-width: 0;
    /* Prevent the content from overflowing */
    padding-right: 10px;
    /* Add slight padding to avoid overlap */
}

.content-area.shrink {
    flex: 0.68;
    /* Slightly smaller to provide more space for details */
}

.implant_details {
    flex: 0.32;
    /* Adjusted to match shrink */
    overflow-y: auto;
    transition: all 0.3s ease-in-out;
    padding-left: 10px;
    border-left: 1px solid rgb(94, 94, 94);
    margin-left: 10px;
    min-width: 280px;
    /* Ensure the details panel doesn't shrink too much */
}

.implant-details-container {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    width: 100%;
}

.implant-detail {
    background: #fff;
    border-radius: 15px;
    box-shadow: 3px 3px 15px #c2c2c2;
    padding: 8px;
    width: calc(100% - 20px);
    /* Default to full width */
    padding-left: 10px;
    font-size: medium;
}

.label-text {
    font-size: 0.9rem;
    color: #6c757d;
    /* Muted text for the label */
    margin-bottom: 5px;
    display: block;
    /* Ensure label appears above */
}

.value-text {
    font-size: 1rem;
    font-weight: bold;
    color: #000;
}

.table {
    width: 100%;
    /* Ensure table stays within bounds */
    table-layout: fixed;
    /* Prevent columns from expanding uncontrollably */
    word-wrap: break-word;
    /* Handle long text gracefully */
}

th,
td {
    text-align: left;
    vertical-align: middle;
    padding: 8px;
}


.content-area.w-100 {
    width: 100%;
    transition: width 0.3s ease-in-out;
}

.label-text,
.value-text {
    font-size: small;
}

.active2 {
    background-color: #ffefbb;
    /* Light blue background */
    font-weight: bold;
    /* Make the text bold */
}

.modal-header {
    background-color: #6DB4E3;
}

.modal-title {
    color: white;
}

.modal-content {
    border: none;
    margin-top: 10vw;
}
</style>